import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import Loader from './../shared/loader'
import Pagination from './../shared/pagination'
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import download from 'downloadjs';
import csvHelper from '../reports/importjsontocsv';
Vue.component("downloadExcel", JsonExcel);
import moment from 'moment';
export default {
	name: 'PackingBox',
	components: {
		Paginate,
		Loader,
		Pagination,
		JsonExcel,
		download,
	},

	data: function() {
		return {
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			// currentPage: 0,
			listBoxtypeData: [],
			listboxdata: [],
			addboxemodal: false,
			id: '',
			boxtype: '',
			searchboxtype: '',
			length: '',
			breadth: '',
			height: '',
			boxcreate: '',
			quantity: '',
			isLoading: false,
			resultCount: '',
			userid: '',
			clientsearch: '',
			boxtypesearch: '',
			warehousesearch: '',
			boxid:'',
			boxcode:'',
      boxname:'',
			length:'',
			width:'',
			height:'',
			tareweight:'',
			weightcapacity:'',
			listClientData: [],
			listWarehouseData: [],
			// pageno: 0,
			// pageCount: 0,
			// pageLimit: 10,
			client: '',
			clientid: '',
			warehouse: '',
			warehouseid: '',
			showSelectClient: false,
			showSelectWarehouse: false,
			ClientErr: '',
			WarehouseErr: '',
			boxcode1:'',
			show:'',
			limitExeed:'',
			download: true,
			listReportDataforxls: [],
			csvFieldsForXls: {},
			reportname: '',
			channellist: [],
			searchchannel:'',
			searchchannel1:'',
			imageurl:'',
			recordLimit:0,

		}
	},

	created: function() {},
	// when a page loads,mounted() will be call
	filters: {
		moment: function(dates) {
			return moment(dates).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail');
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userid = userdetail.userid;

		this.pageno = 0;

		this.reportname = this.$t('editedjson.packingBoxReport')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!=='undefined')
		{
		this.getSalesChannels();
		}
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// /this.getClientList();
				//this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.getboxdata();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}

	},
	methods: {
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getAuditListForXLS(3)
			}
		},

		getAuditListForXLS(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var dataFilter = {};
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';


			this.input = ({
				'clientid': window.localStorage.getItem("selectedClient"),
				'offset': (this.currentPage - 1) * 10,
				'limit': this.pageLimit,
				'csvData': csvCheck,
				'userid':this.userid,
				'boxcode':this.boxcode1,
				'saleschannel':this.searchchannel1
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getpackingboxlist',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.count < 10000) {
							this.listReportDataforxls = [];
							this.csvFieldsForXls[this.$t('common.boxId')]= 'boxid';
							this.csvFieldsForXls[this.$t('boxList.boxCode')]= 'boxcode';
							this.csvFieldsForXls[this.$t('boxList.boxName')]= 'boxname';
							this.csvFieldsForXls[this.$t('boxList.length')]= 'length';
							this.csvFieldsForXls[this.$t('boxList.width')]= 'width';
							this.csvFieldsForXls[this.$t('boxList.height')]= 'height';
							this.csvFieldsForXls[this.$t('boxList.tareWeight')]= 'tareweight';
							this.csvFieldsForXls[this.$t('boxList.weightCapacity')]= 'weightcapacity';
							this.csvFieldsForXls[this.$t('common.salesChannel')]= 'saleschannel';
							this.csvFieldsForXls[this.$t('printProductDetails.imageUrl')]= 'imageurl';

							this.listReportDataforxls = result.data.data.rows;
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					}

				}, error => {
					console.error(error);
				})
		},


		////////
		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			'clientid': this.clientid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			'warehouseid': this.warehouseid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// clientSelected(type) {
		// 	this.warehousesearch = '';
		// 	if (type == 'list') {
		// 		this.clientid = this.clientsearch;
		// 		if (this.clientid) {
		// 			this.getSalesChannels();
		// 			if (!this.warehouseid) {
		// 				this.getWarehouseList();
		// 			} else {
		// 				// this.getboxdata();
		// 			}
		// 		}
		// 	} else {
		// 		this.clientid = this.client;
		// 		this.getSalesChannels();
		// 			this.getWarehouseList();
		// 	}
		// },

		// warehouseSelected(type) {
		// 	if (type == 'list') {
		// 		this.warehouseid = this.warehousesearch;
		// 		if (this.warehouseid) {
		// 			if (!this.clientid) {
		// 				this.getClientList();
		// 			} else {
		// 				// this.getboxdata();
		// 			}
		// 		}
		// 	} else {
		// 		this.warehouseid = this.warehouse;
		// 	}
		// },

		addNewBox() {
			//document.getElementById("quantity").value = '';
			this.boxcreate = "add";
			this.addboxemodal = true;
			this.boxcode = '';
			this.boxname = '';
			this.length = '';
			this.width = '';
			this.height = '';
			this.tareweight = '';
			this.weightcapacity = ''
			this.searchchannel = '';
			this.client = '';
			this.warehouse = '';
			this.imageurl ='';
			this.$validator.reset();
			this.errors.clear();

		},

		closeaddboxemodal() {
			//document.getElementById("quantity").value = '';
			this.addboxemodal = false;
			this.boxcode = '';
			this.boxname = '';
			this.length = '';
			this.width = '';
			this.height = '';
			this.tareweight = '';
			this.weightcapacity = ''
			this.searchchannel = '';
			this.client = '';
			this.warehouse = '';
			this.imageurl ='';
			this.$validator.reset();
			this.errors.clear();
		},
		showEditForm(data) {
			//document.getElementById("quantity").value = '';
			this.boxcreate = "edit";
			this.errors.clear();
			this.addboxemodal = true;
			this.boxid = data.boxid;
			this.boxcode = data.boxcode;
			this.boxname = data.boxname;
			this.length = data.length;
			this.width = data.width;
			this.height = data.height;
			this.tareweight = data.tareweight;
			this.weightcapacity = data.weightcapacity;
			this.imageurl = data.imageurl;
			this.searchchannel = data.saleschannel;
			this.client = this.clientid;
			this.warehouse = this.warehouseid;
			this.$validator.reset();

		},
		updatebox(boxid){
			//console.log(boxid);
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if(this.imageurl == null){
				this.imageurl = '';
			}
			axios({
					method: "POST",
					url: apiUrl.api_url + "updatePackingbox",
					data: {
						clientid: window.localStorage.getItem("selectedClient"),
						//userid: this.userid,
						boxcode: this.boxcode,
			      boxname: this.boxname,
		      	height:this.height,
			      width:this.width,
			      length:this.length,
			      tareweight:this.tareweight,
		       	weightcapacity:this.weightcapacity,
			      saleschannel:this.searchchannel,
						boxid:boxid,
						imageurl:this.imageurl,
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(response => {
					this.isLoading = true;
					if (response.data.ErrorCode == 0) {
						this.isLoading = false;
						this.$alertify.success(response.data.msg);
						this.addboxemodal = false;
						this.getboxdata();
					} else if (response.data.ErrorCode == -1) {
						this.isLoading = false;
						this.$alertify.error(response.data.msg);
						this.addboxemodal = false;
						this.getboxdata();
					}

				})
				.catch(httpException => {
					console.error("exception is:::::::::", httpException);
				});
		},

		// this function for pagination
		getSalesChannels() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			if (window.localStorage.getItem("selectedClient") == '') {
				this.WarehouseErr = this.$t('srReport.clientError');
				return false;
			}
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'orderSalesChannelList',
					'data': {
						clientid: window.localStorage.getItem("selectedClient")
					},
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.channellist = result.data.data;
				}, error => {
					console.error(error);
				});
		},

		// This function for get box list
		getboxdata(csvCheck=0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
				this.currentPage=1;
			}

			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.ClientErr = this.$t('common.clientError');
				this.pageno = this.pageCount = 0;
				this.listboxdata = [];
				return false;
			}

			this.input = ({
				'clientid': window.localStorage.getItem("selectedClient"),
				'offset': (this.currentPage - 1) * 10,
				'limit': this.pageLimit,
				'csvData': csvCheck,
				'userid':this.userid,
				'boxcode':this.boxcode1,
				'saleschannel':this.searchchannel1
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			if (window.localStorage.getItem("selectedClient")) {
				this.isLoading = true;
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getpackingboxlist',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
						if (csvCheck == 1) {
							if(result.data.data.count < 10000){
							this.show = true;
							this.download = false;
							this.listAuditDatacsv = [];
							this.csvFields = {
								'boxid' : this.$t('common.boxId') ,
 								'boxcode': this.$t('boxList.boxCode'),
 								'boxname':this.$t('boxList.boxName'),
 							  	'length': this.$t('boxList.length'),
 								'width': this.$t('boxList.width'),
 								'height': this.$t('boxList.height'),
 								'tareweight': this.$t('boxList.tareWeight'),
 								'weightcapacity': this.$t('boxList.weightCapacity'),
 								'saleschannel': this.$t('common.salesChannel'),
								'imageurl': this.$t('printProductDetails.imageUrl'),
							};
							var dateFilter = [];
							var skipFilter = [];
							this.listAuditDatacsv = [];
							this.listAuditDatacsv1=[]
							this.listAuditDatacsv = result.data.data.rows;
							csvHelper.data.jsonToCSV(this.$t('editedjson.packingBoxReport'), this.listAuditDatacsv, this.csvFields, dateFilter, skipFilter, dataFilter);
							this.isLoading = false;
			        }else{
								this.isLoading = false;
								this.$alertify.success(this.$t('common.reportSizeError'));
							}
						}else{
						this.listboxdata = result.data.data.rows;
						this.resultCount = result.data.data.count;
						this.totalRows = result.data.data.count;

						this.setPageCounts(result.data.data.count);
						this.isLoading = false;
						}
						//console.log(this.listboxdata.length)
					}, error => {
						console.error(error);
					})
			} else {
				this.listboxdata = [];
				this.resultCount = 0;
				this.setPageCounts(0);

				if (!window.localStorage.getItem("selectedClient")) {
					this.ClientErr = this.$t('srReport.clientError');
				}

			}
		},

		savebox() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
					method: "POST",
					url: apiUrl.api_url + "createPackingbox",
					data: {
						clientid: window.localStorage.getItem("selectedClient"),
						//userid: this.userid,
						boxcode: this.boxcode,
			      boxname: this.boxname,
		      	height:this.height,
			      width:this.width,
			      length:this.length,
			      tareweight:this.tareweight,
		       	weightcapacity:this.weightcapacity,
			      saleschannel:this.searchchannel,
						imageurl:this.imageurl,
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(response => {
					this.isLoading = true;
					if (response.data.ErrorCode == 0) {
						this.isLoading = false;
						this.client = '';
						this.$alertify.success(response.data.msg);
						this.addboxemodal = false;
					} else if (response.data.ErrorCode == -1) {
						this.isLoading = false;
						this.$alertify.error(response.data.msg);
						this.addboxemodal = false;
					}

				})
				.catch(httpException => {
					console.error("exception is:::::::::", httpException);
				});
		},

		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * this.pageLimit;
		// 	this.getboxdata()
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getboxdata()
		},

		//Sets total number of pages
		setPageCounts(total_rows) {
			if (total_rows > 0) {
				if (total_rows <= this.pageLimit) {
					this.totalPage = 1;
				} else {
					this.totalPage = Math.ceil(total_rows / this.pageLimit);
				}
			} else {
				this.totalPage = 0;
			}
		},

		resetFormData() {
			this.boxid='';
			this.boxcode='';
			this.boxname= '';
			this.searchchannel = '';
			this.searchchannel1 = '';
			this.height='';
			this.weight = '';
			this.weightcapacity = '';
			this.length = '';
			this.tareweight = '';
			this.totalRows = 0;
			this.clientsearch = '';
			this.warehousesearch = '';
			this.imageurl = '',
			this.boxcode1 = '';
			this.totalPage = 0;
			this.listBoxtypeData = [];
			// this.channellist = [];
			this.listboxdata = [];
			this.resultCount = 0;
			this.ClientErr = "";
			this.WarehouseErr = "";
			if (this.user_type == 'warehouse_user') {
				this.clientid = '';
			} else if (this.user_type == 'client_user') {
				this.warehouseid = '';
			} else {
				this.clientid = '';
				this.warehouse = '';
				this.warehouseid = '';
			}
		},

		onSubmit: function(e) {
			this.$validator
				.validateAll()
				.then((result) => {
					if (result) {
						console.log("form is valid", this.model);
						event.target.reset();
					} else {
						return false;
					}

				})
				.catch(() => {
					console.log("errors exist", this.errors);
				});
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/packingboxmaster/packingboxmaster.component.js